module.exports = __webpack_public_path__ + "img/car-speed-limiter.8ea5410f.svg";